
import { Vue, Component, Ref } from 'vue-property-decorator';
import { AuthEnum } from '@/services/permission.service';
import CopySPUModal from './components/CopySPUModal.vue';
import SPUTable from './components/SPUTable.vue';
import DraggableFixedTable from './components/DraggableFixedTable.vue';
import RebuildSPUModal from './components/RebuildSPUModal.vue';

@Component({
  components: {
    'copy-spu': CopySPUModal,
    SPUTable,
    DraggableFixedTable,
   'rebuild-spu': RebuildSPUModal,
  },
})
export default class Goods extends Vue {
  copyVisible = false;

  rebuildVisible = false;

  AuthEnum = AuthEnum;

  needRefresh = false;

  @Ref()
  spuTable!: SPUTable;

  shopId = '-1';

  created() {
    const { shopId } = this.$route.params;
    this.shopId = shopId;
  }

  /** * 返回 */
  back() {
    this.$confirm({
      title: '确定要离开吗',
      content: '请确定当前商品信息是否已保存！',
      onOk: () => {
        // eslint-disable-next-line implicit-arrow-linebreak
        const { type } = this.$route.params;
        if (type === 'virtualShop') {
          this.$router.push({
            name: 'main.shop.platformSpus',
            params: {
              shopId: this.shopId as string,
            },
          });
        } else {
          this.$router.push({
            name: 'main.shop.detail',
            params: {
              id: this.shopId as string,
            },
          });
        }
      },
      onCancel: () => { },
    });
  }

  /** 刷新商品列表 */
  refreshGoods() {
    this.needRefresh = true;
    this.copyVisible = false;
    this.rebuildVisible = false;
  }

  add() {
    this.spuTable.add();
  }
}
